import store from '../../redux/store'
import { stores, defaultStore } from '../../translations'

export function startGame(gameName) {
  gameEvent('level_start', gameName)
}

export function endGame(gameName, success, hasTicket) {
  gameEvent('level_end', gameName, {
    result: success ? (hasTicket ? 'success_with_ticket' : 'success_without_ticket') : 'fail',
  })
}

export function gameEvent(actionType, gameName, data) {
  send({
    event: 'ga4',
    event_name: actionType,
    application: 'portal',
    flow: 'special_project',
    step: '15_years',
    item_name: gameName,
    user_id: getProfileID(),
    ...data,
  })
}

export function buttonClick(item_name) {
  send({
    event: 'ga4',
    event_name: 'click_cta',
    application: 'portal',
    flow: 'special_project',
    step: '15_years',
    item_name,
    profile_id: getProfileID(),
  })
}

function send(data) {
  if (!window.dataLayer) window.dataLayer = []
  console.log('analytics:send', data)

  window.dataLayer.push(data)
}

function getProfileID() {
  return store.getState().user?.profile?.c?.id
}

/**
 * Маппинг store -> категория события для аналитики
 */
const EVENT_CATEGORY_BY_STORE = {
  [stores.ru]: 'lp_tamagochi',
  [stores.kz]: 'lp_tamagochi_kz',
  [stores.ae]: 'lp_tamagochi_ae',
  [stores.qa]: 'lp_tamagochi_qa',
  [stores.sa]: 'lp_tamagochi_sa',
}

const NEW_EVENT_CATEGORY_BY_STORE = {
  [stores.ru]: 'lp_tamagochi_ru',
  [stores.kz]: 'lp_tamagochi_kz',
  [stores.ae]: 'lp_tamagochi_ae',
  [stores.qa]: 'lp_tamagochi_qa',
  [stores.sa]: 'lp_tamagochi_sa',
}

/**
 * Получает текущий store из Redux или использует defaultStore
 * @returns {string} - код магазина (ru/kz/ae/qa/sa)
 */
export function getCurrentStore() {
  const appInfoData = store.getState().requests?.appInfoData
  const storeCode = appInfoData?.store

  // Проверяем, что store валидный
  if (storeCode && Object.values(stores).includes(storeCode)) {
    return storeCode
  }

  return defaultStore
}

/**
 * Возвращает категорию события для аналитики на основе текущего store
 * @param {boolean} isNewEvent - флаг, указывающий что используется новый тип события
 * @returns {string} - категория события (например: 'lp_tamagochi', 'lp_tamagochi_ru', 'lp_tamagochi_kz', 'lp_tamagochi_ae' и т.д.)
 */
export function getEventCategory({ isNewEvent = false } = {}) {
  const currentStore = getCurrentStore()

  return isNewEvent
    ? NEW_EVENT_CATEGORY_BY_STORE[currentStore]
    : EVENT_CATEGORY_BY_STORE[currentStore]
}
